const input = { width: '100%', padding: 10, borderRadius: 8, border: '1px solid #334155', background: '#0f172a', color: 'white' }
const label = { display: 'block', fontSize: 14, color: '#94a3b8', marginBottom: 6 }

export default function QuestionForm({ form, setForm, categories, domains, showChoices = true }) {
  const updateChoice = (index, field, value) => {
    const next = [...(form.choices || [])]
    next[index] = { ...next[index], [field]: value }
    setForm({ ...form, choices: next })
  }

  const markCorrect = (index) => {
    const next = (form.choices || []).map((choice, i) => ({ ...choice, is_correct: i === index }))
    setForm({ ...form, choices: next })
  }

  return (
    <>
      <label style={label}>Admin title</label>
      <input style={input} value={form.admin_title || ''} onChange={e => setForm({ ...form, admin_title: e.target.value })} />
      <div style={{ height: 12 }} />
      <label style={label}>Stem</label>
      <textarea style={{ ...input, minHeight: 120 }} value={form.stem || ''} onChange={e => setForm({ ...form, stem: e.target.value })} />
      <div style={{ height: 12 }} />
      <label style={label}>Brief rationale</label>
      <textarea style={{ ...input, minHeight: 80 }} value={form.rationale_brief || ''} onChange={e => setForm({ ...form, rationale_brief: e.target.value })} />
      <div style={{ height: 12 }} />
      <label style={label}>Full rationale</label>
      <textarea style={{ ...input, minHeight: 120 }} value={form.rationale_full || ''} onChange={e => setForm({ ...form, rationale_full: e.target.value })} />
      <div style={{ height: 12 }} />
      <label style={label}>Distractor rationale</label>
      <textarea style={{ ...input, minHeight: 100 }} value={form.distractor_rationale || ''} onChange={e => setForm({ ...form, distractor_rationale: e.target.value })} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginTop: 12 }}>
        <div>
          <label style={label}>Status</label>
          <select style={input} value={form.status || ''} onChange={e => setForm({ ...form, status: e.target.value })}>
            <option value="imported">imported</option>
            <option value="needs_review">needs_review</option>
            <option value="approved">approved</option>
            <option value="archived">archived</option>
          </select>
        </div>
        <div>
          <label style={label}>Category</label>
          <select style={input} value={form.primary_category_id || ''} onChange={e => setForm({ ...form, primary_category_id: e.target.value })}>
            <option value="">None</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div>
          <label style={label}>VTNE domain</label>
          <select style={input} value={form.vtne_domain_id || ''} onChange={e => setForm({ ...form, vtne_domain_id: e.target.value })}>
            <option value="">None</option>
            {domains.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginTop: 12 }}>
        <div>
          <label style={label}>Confidence</label>
          <select style={input} value={form.confidence || ''} onChange={e => setForm({ ...form, confidence: e.target.value })}>
            <option value="">None</option>
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
        </div>
        <div>
          <label style={label}>Difficulty</label>
          <select style={input} value={form.difficulty || ''} onChange={e => setForm({ ...form, difficulty: e.target.value })}>
            <option value="">None</option>
            <option value="easy">easy</option>
            <option value="moderate">moderate</option>
            <option value="difficult">difficult</option>
          </select>
        </div>
        <div>
          <label style={label}>Cognitive level</label>
          <select style={input} value={form.cognitive_level || ''} onChange={e => setForm({ ...form, cognitive_level: e.target.value })}>
            <option value="">None</option>
            <option value="recall">recall</option>
            <option value="application">application</option>
            <option value="analysis">analysis</option>
          </select>
        </div>
      </div>
      <div style={{ height: 12 }} />
      <label style={label}>Notes</label>
      <textarea style={{ ...input, minHeight: 80 }} value={form.notes || ''} onChange={e => setForm({ ...form, notes: e.target.value })} />

      {showChoices && (
        <>
          <div style={{ height: 16 }} />
          <h3>Choices</h3>
          {(form.choices || []).map((choice, index) => (
            <div key={choice.label || index} style={{ background: '#0f172a', padding: 12, borderRadius: 8, marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <strong>{choice.label}</strong>
                <label style={{ color: '#94a3b8' }}>
                  <input type="radio" checked={!!choice.is_correct} onChange={() => markCorrect(index)} /> correct
                </label>
              </div>
              <textarea style={{ ...input, minHeight: 70 }} value={choice.choice_text || ''} onChange={e => updateChoice(index, 'choice_text', e.target.value)} />
            </div>
          ))}
        </>
      )}
    </>
  )
}
